import { Module } from 'vuex';
import getters from './signature.getters';
import mutations from './signature.mutations';
import actions from './signature.actions';

import { ISignState } from './signature.types';

const state = {
  signature: undefined,
};

const signModule: Module<ISignState, any> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default signModule;
